import React from 'react';
import { useIsMobile } from '../../utils/useIsMobile';
import MiniProgramLaunchButton from '../cta/MiniProgramLaunchButton';

const PRIMARY = '#3eb574';

const MobileCtaBar: React.FC = () => {
  const mobile = useIsMobile();
  if (!mobile) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 200,
      padding: '12px 20px calc(12px + env(safe-area-inset-bottom, 0px))',
      background: 'rgba(255,255,255,0.94)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      borderTop: '1px solid rgba(226,232,240,0.6)',
    }}>
      <MiniProgramLaunchButton
        label="免费体验 14 天"
        withArrow
        fullWidth
        style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: 52,
        fontSize: 16,
        fontWeight: 700,
        borderRadius: 14,
        background: PRIMARY,
        color: 'white',
        border: 'none',
        cursor: 'pointer',
        letterSpacing: '-0.2px',
        }}
      />
    </div>
  );
};

export default MobileCtaBar;
